const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
// @components
const EmptyCustomViewOption = require('./dropDownOptions/emptyCustomViewOption');
const CustomViewOption = require('./dropDownOptions/customViewOption');
const PortfolioListErrorState = require('./dropDownOptions/portfolioListErrorState').portfolioListErrorState;
// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;
// @actions
const myWalletActions = require('actions/myWallet');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');
const brokerCustomWalletStocksByTypeActions = require('../../../actions/brokerCustomWalletStocksByType');
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const brokerCustomWalletInvestmentsActions = require('../../../actions/brokerCustomWalletInvestments');
const customWalletPortfoliosActions = require('../../../actions/brokerCustomWalletGetPortfoliosList');
const BrokerCustomWalletLoaderActions = require('../../../actions/brokerCustomWalletLoader');

// @ constants
const { BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME, BROKER_CUSTOM_WALLET_GENERAL_VIEW } = require('../../../constants/index');

class BrokerCustomViewsDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelectedView = this.handleSelectedView.bind(this);
    }

    getCustomViewsOptions() {
        const { immBrokerCustomWalletPortfolios } = this.props;
        const isWalletsRequestError = immBrokerCustomWalletPortfolios.get('isWalletsRequestError');

        const options = immBrokerCustomWalletPortfolios.get('customWallets').toJS().map( cw => {
            return  {
                value: cw.descriptionPortfolioAccount,
                label: cw.descriptionPortfolioAccount,
            };
        });

        if (options.length === 0) {
            if(isWalletsRequestError) {
                return options.concat( [{value: BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME, label: formatText('brokerCustomWallet-allPortfolios')}] );
            }
        }
        if (options.length > 1) {
            return options.concat([{ value: "show-more-link", label: "show-more-link", isLink: true }]);
        }
        return options;
    }

    handleSelectedView(event) {
        const {
            immBrokerCustomWalletPortfolios,
            outdateMyInvestments,
            outdateCustomWalletInvestments,
            changeSelectedView,
            getCustomWalletStocksByType,
            getStocksByType,
            getEvolutionData,
        } = this.props;
        const name = event.value;
        const selectedItem = immBrokerCustomWalletPortfolios.get('customWallets').find(item => item.get('descriptionPortfolioAccount') === name);
        const isWalletsRequestError = immBrokerCustomWalletPortfolios.get('isWalletsRequestError');
        const idPortfolioAccount = selectedItem.get('idPortfolioAccount');

        if (!isWalletsRequestError) {
            outdateMyInvestments();
            changeSelectedView(name);
            if (idPortfolioAccount != BROKER_CUSTOM_WALLET_GENERAL_VIEW) {
                outdateCustomWalletInvestments();
                getCustomWalletStocksByType(idPortfolioAccount);
            }else{
                getStocksByType();
            }
            __CONTACT_CENTER__ && getEvolutionData(idPortfolioAccount);
        }
    }

    render() {
        const { immMyWalletCharts, immBrokerCustomWalletPortfolios, immMyInvestments, immBrokerCustomWalletInvestments } = this.props;
        const customViewsOptions = this.getCustomViewsOptions();
        const isWalletsRequestError = immBrokerCustomWalletPortfolios.get('isWalletsRequestError');
        const isFetching = immBrokerCustomWalletPortfolios.get('isFetching');
        const isFetchingMyInvestments = immMyInvestments.get('isFetching');
        const isFetchingCustomWalletInvestments = immBrokerCustomWalletInvestments.get('isFetching');

        let optionComponent;
        let value = immMyWalletCharts.get('selectedView');

        if (!isFetching) {
            if (customViewsOptions.length === 1) {
                if (isWalletsRequestError) {
                    optionComponent = PortfolioListErrorState;
                    value = BROKER_CUSTOM_CONFIG_WALLET_GENERAL_NAME;
                }
                else {
                    optionComponent = EmptyCustomViewOption;
                }
            } else {
                optionComponent = CustomViewOption;
            }
        }

        return (
            <OKSelect
                onChange={this.handleSelectedView}
                options={customViewsOptions}
                optionComponent={optionComponent}
                value={value}
                searchable={false}
                disabled={isFetching || isFetchingMyInvestments || isFetchingCustomWalletInvestments}
            />
        );
    }
}

BrokerCustomViewsDropdown.propTypes = {
    immMyWalletCharts: PropTypes.object.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immBrokerCustomWalletInvestments: PropTypes.object.isRequired,
    getEvolutionData: PropTypes.func.isRequired,
    getPortfolioList: PropTypes.func.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getCustomWalletStocksByType: PropTypes.func.isRequired,
    outdateMyInvestments: PropTypes.func.isRequired,
    outdateCustomWalletInvestments: PropTypes.func.isRequired,
    changeSelectedView: PropTypes.func.isRequired,
};

module.exports.BrokerCustomViewsDropdown = connect(
    state => ({
        immMyWalletCharts: state.myWalletCharts,
        immBrokerCustomWalletPortfolios: state.brokerCustomWalletPortfolios,
        immMyInvestments: state.brokerMyInvestments,
        immBrokerCustomWalletInvestments: state.brokerCustomWalletInvestments
    }),
    {
        getPortfolioList: customWalletPortfoliosActions.getPortfolioList,
        getStocksByType: brokerStocksByTypeActions.getStocksByType,
        getCustomWalletStocksByType: brokerCustomWalletStocksByTypeActions.getStocksByType,
        outdateMyInvestments: brokerMyInvestmentsActions.outdateMyInvestments,
        outdateCustomWalletInvestments: brokerCustomWalletInvestmentsActions.outdateMyInvestments,
        changeSelectedView: myWalletActions.changeSelectedView,
        getEvolutionData: myWalletActions.getEvolutionData,
        getWalletData: BrokerCustomWalletLoaderActions.getWalletData,
    }
)(BrokerCustomViewsDropdown);
